/**
 * Convert Category Text from user readable text to system category text.
 *
 * ===============================================
 * @param {string} text User readable category text.
 * @return {string} system category text
 */
export function handleCategoryTextConverter(text: string) {
  switch (text) {
    case 'streetwear':
    case 'fashion':
    case 'apparel':
      return 'apparels';
    case 'luxury':
      return 'handbags';
    case 'lifestyle':
    case 'toys':
    case 'electronics-collectibles':
      return 'lifestyles';
    default:
      return text;
  }
}

/**
 * Convert Category Text from system category text to user readable text.
 *
 * ===============================================
 * @param {string} text system category text.
 * @return {string} User readable category text
 */
export function handleCategoryTextConverterInvert(text: string) {
  switch (text) {
    case 'apparels':
    case 'streetwear':
      return 'apparel';
    case 'handbags':
      return 'luxury';
    case 'lifestyles':
      return 'electronics-collectibles';
    default:
      return text;
  }
}

/**
 * Convert Status Text from user readable text to system status text.
 *
 * ===============================================
 * @param {string} text User readable status text.
 * @return {string} system status text
 */
export function handleStatusTextConverter(text: string) {
  switch (text) {
    case 'Active':
      return 'active';
    case 'Expired':
      return 'expired';
    case 'No Expiry':
      return 'no_expiry';
    case 'Awaiting Payment':
      return 'pending';
    case 'Awaiting Payment Approval':
      return 'approval';
    case 'Awaiting Seller Confirmation':
      return 'pending';
    case 'Waiting for Seller to Deliver':
      return 'seller_confirmation';
    case 'En route to Kick Avenue':
      return 'en_route';
    case 'Authentication Process':
      return 'verification_process';
    case 'Proses Review':
      return 'in_review';
    case 'Authentication Process - Success':
      return 'verification_passed';
    case 'Delivery to Customer':
      return 'delivering';
    case 'Completed':
      return 'completed';
    case 'Refund Process':
      return 'refund_process';
    case 'Refund Completed':
      return 'refund_completed';
    case 'Cancelled':
      return 'cancelled';
    case 'Failed':
      return 'failed';
    default:
      return text;
  }
}

/**
 * Convert Status Text from system status text to user readable text.
 *
 * ===============================================
 * @param {string} text system status text.
 * @return {string} User readable status text
 */
export function handleStatusTextConverterInvert(text: string) {
  switch (text) {
    case 'active':
      return 'Active';
    case 'expired':
      return 'Expired';
    case 'no_expiry':
      return 'No Expiry';
    case 'pending':
      return 'Awaiting Payment';
    case 'approval':
      return 'Awaiting Payment Approval';
    case 'pending':
      return 'Awaiting Seller Confirmation';
    case 'seller_confirmation':
      return 'Waiting for Seller to Deliver';
    case 'en_route':
      return 'En route to Kick Avenue';
    case 'verification_process':
      return 'Authentication Process';
    case 'in_review':
      return 'Proses Review';
    case 'verification_passed':
      return 'Authentication Process - Success';
    case 'delivering':
      return 'Delivery to Customer';
    case 'completed':
      return 'Completed';
    case 'refund_process':
      return 'Refund Process';
    case 'refund':
      return 'Refund Completed';
    case 'cancelled':
      return 'Cancelled';
    case 'failed':
      return 'Failed';
    default:
      return text;
  }
}

/**
 * Convert Text to Title Case.
 *
 * ===============================================
 * @param {string} Text you want to convert.
 * @return {string} Converted Title Case Text
 */
export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  });
}
